// extracted by mini-css-extract-plugin
export default {"container":"product-list-profile-chip__container___3pkq3","label":"product-list-profile-chip__label___LdGb4","icon":"product-list-profile-chip__icon___nlCfz"};